<style scoped>
#abook {
	padding: 10px;
	min-height: 100%;
}
#abook_toolbar {
	padding: 0px;
}
.back_ground{
	min-height:100%;
	background-color: white;
}
.label-font {
	font-weight: bold;
}

.label_red * label {
	color: red !important;
}

</style>

<template>
	<v-container id="abook_toolbar" fluid>
		<v-alert type="error" v-if="errormsg != ''">
			{{errormsg}}
		</v-alert>

		<v-row no-gutters>
			<v-col cols="12" class="toolbar">
				<v-btn 
					small
					class="mr-1 text-capitalize"
					@click="create()"
				>
					New
				</v-btn>
				<v-btn 
					small
					class="mr-1 text-capitalize" 
					@click="edit()" disabled
				>
					Edit
				</v-btn>
				<!-- Need to add more -->
			</v-col>
		</v-row>
		
		<div class="abook">
			<v-row no-gutters>
				<v-col cols="12" md="3" class="mb-3">
					<v-card 
						class="back_ground ma-4 pa-2"
						elevation="3"
					>
						<div class="ma-2 pa-2">
							<v-user-avatar
								v-if="abook.id > 0"
								size="36"
								color="#00AAFD"
								class="font-weight-light"
								:code="abook.short"
								:image="'/api/addressbook/' + abook.id + '/image.png'"
								left
							/>
							<span 
								class="
									ml-2 
									text-xl-h6
									text-lg-h6 
									text-md-subtitle-1 
									text-sm-body-1 
									text-body-1 
									font-weight-light
								"
							>
								{{abook.short}} 
							</span>
						</div>

						<v-text-field
							hide-details
							readonly
							label="Address"
							color="#00AAFD"
							v-model="abook.main_address"
							v-if="abook.main_address!=''&on_edit"
							class="ma-2 pa-2"
						>
						</v-text-field>
						<div class="mt-2 ml-2 mb-1 pl-2" v-if="!on_edit&abook.main_address!=''&& isShow()" >
							<span class="text-caption font-weight-light">Address: </span>
							<br/>
							<span 
								class="
									text-xl-subtitle-1 
									text-lg-body-2 
									text-md-body-2
									text-sm-body-2 
									text-body-2"
							>
								{{abook.main_address}} 
							</span>			
						</div>						
						
						<v-text-field
							hide-details
							readonly
							label="Telephone"
							v-model="abook.main_telephone"
							v-if="abook.main_telephone!=''&on_edit"
							class="ma-2 pa-2"
						>
						</v-text-field>

						<div class="mt-2 ml-2 mb-1 pl-2" v-if="!on_edit&abook.main_telephone!=''">
							<span class="text-caption font-weight-light">Telephone: </span><br/>
							<span
								class="
									text-xl-subtitle-1 
									text-lg-subtitle-1 
									text-md-body-2
									text-sm-body-2 
									text-body-2"	
							>
								<a :href="`tel:${abook.main_telephone}`">{{abook.main_telephone}}</a>
							</span>
						</div>
						
						<v-text-field
							hide-details
							readonly
							label="ABN"
							v-model="abook.abn"
							v-if="abook.abn!=''&on_edit"
							class="ma-2 pa-2"
						>
						</v-text-field>
						<div class="mt-2 ml-2 mb-1 pl-2" v-if="!on_edit&abook.abn!=''">
							<span class="text-caption font-weight-light">ABN: </span>
							<br/>
							<span 
								class="
									text-xl-subtitle-1 
									text-lg-subtitle-1 
									text-md-body-2
									text-sm-body-2 
									text-body-2"
							>
								{{abook.abn}} 
							</span>			
						</div>

						<v-text-field
							hide-details
							readonly
							label="ACN"
							v-model="abook.acn"
							v-if="abook.acn!=''&on_edit"
							class="ma-2 pa-2"
						>
						</v-text-field>

						<div class="mt-2 ml-2 mb-1 pl-2" v-if="!on_edit&abook.acn!=''">
							<span class="text-caption font-weight-light">ACN: </span>
							<br/>
							<span 
								class="
									text-xl-subtitle-1 
									text-lg-subtitle-1 
									text-md-body-2
									text-sm-body-2 
									text-body-2"
							>
								{{abook.acn}} 
							</span>			
						</div>						

						<v-text-field
							hide-details
							readonly
							label="Type"
							v-model="abook.flavour_desc"
							v-if="on_edit"
							class="ma-2 pa-2"
						>
						</v-text-field>
						<div class="mt-2 ml-2 mb-1 pl-2" v-if="!on_edit">
							<span class="text-caption font-weight-light">Type: </span>
							<br/>
							<span 
								class="
									text-xl-subtitle-1 
									text-lg-subtitle-1 
									text-md-body-2
									text-sm-body-2 
									text-body-2"
							>
								{{abook.flavour_desc}} 
							</span>			
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" md="9" class="mb-1">
					<v-expansion-panels v-model="panels" multiple popout class="pa-4">
					
						<!--<v-contact-panel ref="contact_panel" class="pa-2"/>
						<v-address-panel ref="address_panel" class="pa-2"/>
						<v-job-panel ref="job_panel" class="pa-2"/>-->
						<component 
							:is="p.panel" 
							:key="p.id" 
							:is_expanded="panels.includes(p.id)"
							v-for="p in panel_components" 
							ref="panels"
							class="mb-1"
						/>
					</v-expansion-panels>
				</v-col>

			</v-row>

		</div>

		
	</v-container>

</template>

<script>
import contact_panel from "@/components/addressbook/contact_panel"
import address_panel from "@/components/addressbook/address_panel"
import job_panel from "@/components/addressbook/job_panel";

/** from 'api/addressbook/meta', no privilege to view others address */
const Addressbook_Types = ['3', '7', '12', '15'];

export default {
	data() {
		return {
			loading: false,
			added_crumb: false,
			on_edit: false,
			errormsg: '',
			panels: [ 0 ],
			panel_components: [	],
			abook: {
				id: 0,
				code: '',
				short: '',
				main_address: '',
				main_telephone:''
			},
			image : ''
			
		}
	},
	mounted() {
		this.load(this.$route.params.id);
	},
	watch: {
		'$route.params.id': function(id) {
			this.$nextTick(() => {
				this.load(id);
			});
		}
	},
	methods: {
		load(abook_id) {
			let self = this; // make sure we can access this inside of our promisses
			this.loading = true;
			this.panel_components = []; // clear our panels so we have control

			// load our addressbook
			axios
				.get("/api/addressbook/" + abook_id, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						self.abook = json.data;

						// we add this the first time around
						if (!self.added_crumb) {
							self.added_crumb = true;

							self.$store.commit("push_breadcrumb", {
								exact: true,
								text: self.abook.short,
								to: self.$route.path
							});
						};
						self.image = '/api/addressbook/' + self.abook.id + '/image.png';
						// self.imgerror = (self.image == '');

						// self.loaded_settings = { ...self.list };

						// hardcoded for now but we should build this based on the type of address book and the priveleges of the user.
						var index = 0;
						//add contact only if its a business for now
						if (self.abook.is_company) {
							self.panel_components.push({ id: index++, panel: contact_panel });
						}
						
						self.panel_components.push({ id: index++, panel: address_panel });
						
						//add jobs panel if this is a client or prospect
						var flavours = ',' + self.abook.flavours + ',';
						if (flavours.includes(',1,')|flavours.includes(',14,')) {
							self.panel_components.push({ id: index++, panel: job_panel });
						}
						
						self.panels = [ 0 ];

						self.$nextTick(() => {
							self.load_panels()
						})
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading = false;
				});
		},
		load_panels() {
			this.$refs.panels.forEach(p => p.load(this.abook.id));
		},
		isShow() {
			let isShow_tmp = true;

			const flavours_arr = this.abook.flavours.split(',');
			const no_privilege_arr = flavours_arr.filter(f => { return Addressbook_Types.includes(f) });

			if (!this.abook.is_company || no_privilege_arr.length !== 0) {
				isShow_tmp = false;
			}
			return isShow_tmp;
		}
	},
}	
</script>